import { render, staticRenderFns } from "./commissionWithdrawal.vue?vue&type=template&id=2ccfc55b&"
import script from "./commissionWithdrawal.vue?vue&type=script&lang=js&"
export * from "./commissionWithdrawal.vue?vue&type=script&lang=js&"
import style0 from "./commissionWithdrawal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports